import {
    FETCH_TRIATHLON_TYPES_FETCHING,
    FETCH_TRIATHLON_TYPES_SUCCESS,
    FETCH_TRIATHLON_TYPES_FAIL
} from 'actions/eventsActions';

const INITIAL_STATE = {
    types: null,
    fetching: false,
    success: false,
    error: false
};

const triathlonTypesFetching = (state) => {
    return {
        ...state,
        types: null,
        fetching: true
    };
};

const triathlonTypesSuccess = (success) => (state, action) => {
    return {
        ...state,
        types: action.data,
        fetching: false,
        success,
        error: !success
    };
};

export const isTriathlonTypesFetching = (state) => {
    return state.triathlonTypes.fetching;
};

export const isTriathlonTypesFetchSuccess = (state) => {
    return state.triathlonTypes.success;
};

export const isTriathlonTypesFetchError = (state) => {
    return state.triathlonTypes.error;
};

export const getTriathlonTypesData = (state) => {
    return state.triathlonTypes.types;
};

const handlers = {
    [FETCH_TRIATHLON_TYPES_FETCHING]: triathlonTypesFetching,
    [FETCH_TRIATHLON_TYPES_SUCCESS]: triathlonTypesSuccess(true),
    [FETCH_TRIATHLON_TYPES_FAIL]: triathlonTypesSuccess(false)
};

export default function triathlonTypes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    } else {
        return handler(state, action);
    }
}
